import _ from 'lodash';

function GameAddCtrl($rootScope, $q, $scope, $state, $stateParams, $timeout, toastr, PlanService, UserService) {
  'ngInject';

  var vm = this;
  vm.appContext = AppContextService.context;

  vm.startGame = function () {

    var dataSetGame = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      date: '2017.10.01',
      time: '17:30:15'
    }

    PlanService.setGame(dataSetGame)
      .then(function (res) {
        var d = $q.defer();

        var dataSetEntry = {
          login_id: vm.appContext.user.login_id,
          uuid: vm.appContext.user.uuid,
          game_id: res.data.game_id,
          user_id: _.map(vm.appContext.players.ourTeam.all, 'user_id').join(),
          status: 'IN', // IN, WAIT, OUT(교체됨)
          is_oppo: 'N'
        }
        d.resolve(dataSetEntry);
        return d.promise;

      })
      .then(function (dataSetEntry) {
        PlanService.setEntry(dataSetEntry).then(function (res) {
          $state.go('Service.game');
        });
      });

  }



}

export default {
  name: 'GameAddCtrl',
  fn: GameAddCtrl
};
